import { Prisma, User } from "@prisma/client";
import { useState } from "react";
import {
    Command,
    CommandEmpty,
    CommandGroup,
    CommandInput,
    CommandItem,
} from "~/components/shadcn/Command";
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "~/components/shadcn/Popover";
import { HiOutlineChevronUpDown } from "react-icons/hi2";
import { GoCheck } from "react-icons/go";
import { cn } from "~/utils/fontsConfig";
import { Button } from "~/components/v3/themed/Button";
import { BASE_INPUT_STYLES } from "~/components/v3/themed/BASE_STYLE_DEFINITIONS";

type SearchUser = Prisma.UserGetPayload<{
    select: {
        id: true;
        name: true;
        email: true;
    };
}>;
interface Props {
    foundUsers: SearchUser[] | null | undefined;
    selected: SearchUser | null;
    setSelected: (user: SearchUser | null) => void;
    setOpen: (isOpen: boolean) => void;
}

const UserCommandGroup = ({
    foundUsers,
    selected,
    setSelected,
    setOpen,
}: Props) => {
    const escapeSelector = (name: string) => {
        return name.replace(/"/g, '\\"');
    };

    return (
        <CommandGroup className="max-h-[300px] overflow-y-auto">
            {foundUsers?.map((user) => (
                <CommandItem
                    key={user.id}
                    value={escapeSelector(user?.name ?? "")}
                    onSelect={() => {
                        setSelected(user);
                        setOpen(false);
                    }}
                >
                    <GoCheck
                        className={cn(
                            "mr-2 h-4 w-4",
                            selected?.id === user.id
                                ? "opacity-100"
                                : "opacity-0",
                        )}
                        aria-hidden="true"
                    />
                    {user.name}
                </CommandItem>
            ))}
        </CommandGroup>
    );
};

export const SearchUser = ({
    users,
    placeholder,
    setQuery,
    selected,
    setSelected,
}: {
    users: SearchUser[] | null | undefined;
    placeholder: string;
    setQuery: (query: string) => void;
    selected: SearchUser | null;
    setSelected: (user: SearchUser | null) => void;
}) => {
    const [open, setOpen] = useState<boolean>(false);

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <Button
                    variant="ghost"
                    role="combobox"
                    aria-expanded={open}
                    className={cn(BASE_INPUT_STYLES, "w-full justify-between")}
                >
                    {selected?.name ?? placeholder}
                    <HiOutlineChevronUpDown
                        className="text-mate ml-2 h-4 w-4 shrink-0 opacity-50"
                        aria-hidden="true"
                    />
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-[60vw] p-0 md:w-[230px]" align="start">
                <Command shouldFilter={false}>
                    <CommandInput
                        placeholder={placeholder}
                        onValueChange={setQuery}
                    />
                    <CommandEmpty>No person found.</CommandEmpty>
                    <UserCommandGroup
                        foundUsers={users}
                        selected={selected}
                        setSelected={setSelected}
                        setOpen={setOpen}
                    />
                </Command>
            </PopoverContent>
        </Popover>
    );
};
